// @ts-strict-ignore
import React from 'react';

import { FormBuilderBlockData } from 'api/cms';
import { AmpHeroBlock } from 'cms/blocks/Amp/AmpHeroBlock';
import { AmpBlockMappingComponentProps } from 'cms/blocks/BlockMapping';

export function AmpFormBuilderBlock({
  content,
  data,
  blockId,
}: AmpBlockMappingComponentProps<FormBuilderBlockData>) {
  return (
    <AmpHeroBlock
      content={content}
      data={{
        ...data,
        // @ts-expect-error fix me
        image: data.bgImage,
        text: data.headline,
        buttonText: data.submitButtonText,
        isEmailSignup: true,
      }}
      blockId={blockId}
    />
  );
}
